type Props = {
  className?: string;
};

export const Available = (props: Props) => {
  return (
    <svg
      {...props}
      width={36}
      height={40}
      viewBox="0 0 45 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44 27V47.75L14.7863 53L1.65649 40.5L1 19.5L30.2137 15L44 27Z"
        fill="#309A66"
      />
      <path
        d="M14.7863 53V31.75M14.7863 53L44 47.75V27M14.7863 53L1.65649 40.5L1 19.5M14.7863 31.75L44 27M14.7863 31.75L1 19.5M44 27L30.2137 15L1 19.5"
        stroke="black"
        strokeWidth={0.656489}
      />
      <path
        d="M1.66667 40.75L15 53V32L1 20L1.66667 40.75Z"
        fill="black"
        fillOpacity={0.3}
      />
      <path
        d="M14.7863 31.9098V53L44 47.7895V27.4436L14.7863 31.9098Z"
        fill="black"
        fillOpacity={0.15}
      />
      <g filter="url(#filter0_d_2132_6784)">
        <rect
          x={10}
          y={3}
          width={24}
          height={24}
          rx={12}
          fill="#025A45"
        />
        <rect
          x={10.5625}
          y={3.5625}
          width={22.875}
          height={22.875}
          rx={11.4375}
          stroke="white"
          strokeWidth={1.125}
        />
        <path
          d="M26.6406 12.0469L20.7344 17.9531L17.7812 15"
          stroke="white"
          strokeWidth={1.125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2132_6784"
          x={5}
          y={0}
          width={34}
          height={34}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2.5} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2132_6784"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2132_6784"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
